export class ApiError extends Error {
  constructor(message: string, readonly status: number) { super(message); this.name = "ApiError"; }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  let response: Response;
  try { response = await fetch(path, { ...options, headers, credentials: "same-origin" }); }
  catch (error) {
    if (options.signal?.aborted || (error instanceof DOMException && error.name === "AbortError")) throw error;
    throw new ApiError("网络连接失败。你的编辑尚在，请检查网络后重试；已提交的生成任务请先查看状态，避免重复启动。", 0);
  }
  if (response.status === 204) return undefined as T;
  let payload: unknown;
  try { payload = await response.json(); }
  catch { throw new ApiError(`服务返回了无法读取的响应（${response.status}），请稍后重试。`, response.status); }
  if (!response.ok) {
    if (response.status === 401 && !path.startsWith("/api/auth/")) window.dispatchEvent(new Event("moyan-session-expired"));
    const message = payload && typeof payload === "object" && "error" in payload && typeof payload.error === "string" ? payload.error : `请求失败 (${response.status})`;
    throw new ApiError(message, response.status);
  }
  return payload as T;
}
export function putJson<T>(path: string, body: unknown): Promise<T> { return api<T>(path, { method: "PUT", body: JSON.stringify(body) }); }
export function postJson<T>(path: string, body: unknown = {}): Promise<T> { return api<T>(path, { method: "POST", body: JSON.stringify(body) }); }
export function patchJson<T>(path: string, body: unknown): Promise<T> { return api<T>(path, { method: "PATCH", body: JSON.stringify(body) }); }
